import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { PrimaryButton, DefaultButton } from '@fluentui/react/lib/Button';
import { closeBoardEditorDialog, isEditingProject, getName } from '../viewstate';
import loc from 'owa-localize';
import {
    createBoardButtonText,
    updateBoardButtonText,
    cancelBoardButtonText,
} from './BoardEditorStrings.locstring.json';
import { createOrUpdateBoardName } from '../viewstate/utils';

export default observer(function BoardEditorFooter() {
    return (
        <div className={styles.footerContent}>
            <PrimaryButton
                className={styles.footerButton}
                text={isEditingProject() ? loc(updateBoardButtonText) : loc(createBoardButtonText)}
                onClick={createOrUpdateBoardName}
                disabled={getName() === ''}
            />
            <DefaultButton
                className={styles.footerButton}
                text={loc(cancelBoardButtonText)}
                onClick={closeBoardEditorDialog}
            />
        </div>
    );
});
